module.exports = __webpack_public_path__ + "img/toscana-mobile.91aec0cf.webp";